function Bio() {
  return (
    <ul className="bio-list" style={{ listStyleType: "disc" }}>
      <li className="p1">
        Open source Bitcoin developer focused on Rust and Bitcoin education
      </li>
      <li className="p1">
        Background in web development and cloud architecture
      </li>
      <li className="p1">
        Built scalable, cost-effective serverless AWS platform at Gebler Tooth Architects
      </li>
      <li className="p1">
        AWS and Terraform certified; experienced across diverse cloud projects
      </li>
      <li className="p1">
        Curious about AI, robotics, embedded systems and more
      </li>
      <li className="p1">
        Digital nomad currently based in Thailand, engaged with the global tech community
      </li>
      <li className="p1">
        Active in the software community through volunteering, hackathons, and conferences
      </li>
    </ul>
  );
}

export default Bio;
